import markdownToTxt from 'markdown-to-txt'
import { useState } from 'react'
import cn from 'classnames'

interface FoldingTextProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string
}

const FoldingText = ({
  text,
  ...attributes
}: FoldingTextProps): JSX.Element => {
  const [folding, setFolding] = useState(true)

  const html = markdownToTxt(text, { escapeHtml: false }).replace(
    /\n/g,
    '<br />'
  )

  function onClick() {
    setFolding(!folding)
  }

  return (
    <div {...attributes}>
      <div
        className={cn({
          'line-clamp-4 lg:line-clamp-[10] cursor-pointer': folding,
        })}
        onClick={onClick}
        dangerouslySetInnerHTML={{
          __html: html,
        }}
      ></div>
      <div className="text-xs mt-4 text-gray-400 " onClick={onClick}>
        {folding ? 'READ MORE' : 'READ LESS'}
        <svg
          className="inline-block h-4 w-4 ml-1"
          xmlns="https://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d={folding ? 'M19 9l-7 7-7-7' : 'M5 15l7-7 7 7'}
          />
        </svg>
      </div>
    </div>
  )
}

export default FoldingText
